import { FaChevronRight } from "react-icons/fa";
import ChatDev from "./ChatDev";
import { ImSpinner2 } from "react-icons/im";

export default function ChatInput({
  state,
  textAreaRef,
  handleInputChange,
  handelsubmit,
  CVoiceRecorder,
  load,
  setLoad,
  handleTranscript,
  isRecording,
  setIsRecording,
}) {
  return (
    <div className="w-full flex flex-col justify-end items-center mb-1 text-base px-5 pt-3 sticky bottom-0 bg-white">
      <div className="flex gap-2 w-full">
        <textarea
          ref={textAreaRef}
          rows={1}
          className="w-full px-5 scrollbar-hide py-3 pr-16 border border-gray-300 rounded-full resize-none overflow-y-auto max-h-[200px] scrollbar-hidden focus:outline-none"
          value={state.ques}
          onChange={handleInputChange}
          onKeyDown={(e) => {
            if (e.shiftKey && e.key === "Enter") return;
            if (e.key === "Enter") {
              e.preventDefault();
              if (!state.loading) handelsubmit(e);
            }
          }}
          placeholder="Enter a message..."
        />
        <div className="flex gap-1">
          <CVoiceRecorder
            load={load}
            setLoad={setLoad}
            handleTranscript={handleTranscript}
            isRecording={isRecording}
            setIsRecording={setIsRecording}
          />
          <button
            className="hover:scale-105"
            onClick={handelsubmit}
            disabled={state.loading}>
            {state.loading ? (
              <ImSpinner2 size={20} className="animate-spin" />
            ) : (
              <FaChevronRight className="w-6 h-6" />
            )}
          </button>
        </div>
      </div>
      <ChatDev />
    </div>
  );
}
